var user = (JSON.parse(localStorage.getItem('user')))
let state = {
  loginError: false,
  otpError: false,
  sessionId: undefined,
  user: user,
  loggedIn: false,
  userType: (user) ? user.icici_customer : false,
  mobile: undefined
}
export default state



// WEBPACK FOOTER //
// ./src/store/login/state.js